define([
    "angular",
    "../edition/monitoringEdition"
], function (angular) {
    "use strict";
    return angular.module("monitoringLocalityModule", ["monitoringModule", "monitoringEditionModule"]);
});